<!-- Hamburger Menu Button -->
<button
  class="relative bg-none border-2 border-transparent cursor-pointer p-2 rounded-sm transition-all duration-200 hover:bg-gray-4"
  data-testid="hamburger-menu"
  (click)="visible = true"
  [attr.aria-label]="TRANSLATION_KEYS.header.OPEN_MENU | translate"
>
  <svg-icon
    src="assets/icons/menu.svg"
    [svgAriaLabel]="''"
    class="w-5 h-5 text-black"
  />
</button>

<!-- Drawer Menu -->
<p-drawer
  [(visible)]="visible"
  position="right"
  [modal]="true"
  [dismissible]="true"
  [fullScreen]="false"
  [blockScroll]="true"
  [closable]="false"
  styleClass="w-80 border border-slate-200 rounded-none [--p-drawer-content-padding:0] [--p-drawer-header-padding:0]"
  (onHide)="closeDrawer()"
  data-testid="menu-drawer"
  role="dialog"
  [attr.aria-label]="TRANSLATION_KEYS.generic.accessibility.MENU_DRAWER | translate"
>

  <ng-template pTemplate="content">
    <div
      pFocusTrap
      class="flex flex-col h-full w-full"
    >
      <div
        class="box-border content-stretch flex items-center justify-between px-8 py-5 relative shrink-0 w-full border-b border-gray-200"
      >
        <!-- User Info -->
        <div
          class="bg-[var(--colors-header-btn-primary)] box-border flex gap-1.5 items-center justify-start pl-[3px] pr-4 py-[3px] relative rounded-[46px] shrink-0 h-fit"
        >
          <ape-avatar
            [forename]="userFirstName"
            [surname]="userLastName"
            [image]="userAvatar"
            [variant]="'full'"
            [size]="'medium'"
          />
        </div>

        <!-- Close Button -->
        <ape-button
          [pAutoFocus]="true"
          [variant]="'primary'"
          [aspect]="'icon-outline'"
          [size]="'medium'"
          [rightIcon]="'assets/icons/x.svg'"
          [ariaLabel]="TRANSLATION_KEYS.generic.accessibility.DRAWER_CLOSE | translate"
          (buttonClick)="closeDrawer()"
        />
      </div>

      <div class="box-border content-stretch flex flex-col gap-5 items-start justify-start relative size-full">
        <div
          class="bg-white box-border content-stretch flex flex-col gap-px items-start justify-start pb-0 pt-px px-0 relative shrink-0 w-full"
        >
          <ape-header-menu-item
            *ngFor="let menuItem of menuItems; trackBy: trackByMenuItemLabel"
            [menuItem]="menuItem"
            class="w-full border-b border-gray-200"
          />
        </div>
      </div>
    </div>
  </ng-template>
</p-drawer>

<!-- Modale di conferma logout -->
<ape-modal
  [visible]="logoutModalVisible"
  [title]="TRANSLATION_KEYS.logout.CONFIRM_TITLE | translate"
  [description]="TRANSLATION_KEYS.logout.CONFIRM_MESSAGE | translate"
  [secondaryActionLabel]="TRANSLATION_KEYS.generic.CANCEL | translate"
  [primaryActionLabel]="TRANSLATION_KEYS.generic.CONFIRM | translate"
  (onCancel)="onCancelLogout()"
  (onConfirm)="onConfirmLogout()"
  (onClose)="onCancelLogout()"
/>
